export default function filter (){
	let inputSearch = $('.faq__search');
	let linkCategory = $('.categoryFaq__link');

	function faqquestions(){
		let form = '#faq .form';
		let search = inputSearch.val();
		let category = $('.categoryFaq__link.active').length > 0 ? $('.categoryFaq__link.active').data('category') : '';

		if(!search && !category){
			//alert('a');
			$('.faq__contentItens').html('<p><b>'+jsi18n.select_category+'</b></p>').slideDown();
		} else{
            $('.modalLoader').show();
            $('.faq__contentItens').css({"opacity":"0.5"});
            $("#pillarName").css({"opacity":"0.5"});
			$.ajax({
				type        : $(form).attr('method'),
				url         : $(form).attr('action'),
				data        : {category: category, search: search, '_token': $('meta[name="csrf-token"]').attr('content')},
				dataType    : "json",
				success:function(data) {
					let content = '';
					if(data.contents.length == 0){
						content = '<p><b>'+jsi18n.no_results+'</b></p>';
					}
					$.each(data.contents, function(key, el){
						content += `<div class="faq__iten">
													<h3 class="faq__question" data-openquestion>${el.title} <i class="fas fa-caret-down"></i></h3>
													<div class="faq__description"><p>${el.description}</p></div>
												</div>`;
					})
					$('.faq__contentItens').html(content).slideDown();
                    $("#pillarName").html(text);
                    $("#pillarNameMobile").html(text);
                    $("#pillarName").css({"opacity":"1"});
                    $('.faq__contentItens').css({"opacity":"1"});

                    $('.modalLoader').hide();
				}
			});
		}
	}

	faqquestions();

	$('#faq .form').submit(function(e){
		e.preventDefault();
		linkCategory.removeClass('active');
		faqquestions();
	})

	linkCategory.click(function(e){
		e.preventDefault();
		if(!$(this).hasClass('active')){
			linkCategory.removeClass('active');
			$(this).addClass('active');
		} else{
			linkCategory.removeClass('active');
		}
		let search = inputSearch.val('');
		faqquestions();
	})
}